// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'f8f4fe435280a6b83f49113b6b997fe6227a4ddb';
export const BUILD_NUMBER = '207';
export const BUILD_TIMESTAMP = '2026-07-23T08:00:26.063Z';
